<template>
  <div class="share">
    <div class="content">
      <transition-group name="fade-fast">
        <div class="section-main" v-show="!shareModalState" key="1">
          <BaseLockup class="lockup"/>
          <div class="container">
            <router-link class="action-container" :to="{ name: 'selection', params: { initialSlide: nextOpponentIndex } }">
              <BaseTextAnimation1 class="action-copy" ref="action-copy">
                <BaseText12 :text="userWonGame ? 'next' : 'play'"/>
              </BaseTextAnimation1>
              <BaseText4 class="action-subcopy" :text="userWonGame? 'Opponent' : 'Again'"/>
            </router-link>
            <div class="image-container">
              <img class="image" :src="userShareImageLocal">
              <div class="share-container" @click="shareModalState = true">
                <BaseTextAnimation1 class="share-copy" ref="share-copy">
                  <BaseText13 text="share"/>
                </BaseTextAnimation1>
                <BaseText4 class="share-subcopy" text="Your replay"/>
              </div>
            </div>
          </div>
          <a :href="$content.buyUrl" target="_blank">
            <BaseButtonBuy class="buy-button"/>
          </a>
        </div>
        <ShareModal @close="shareModalState = false" v-show="shareModalState" key="2"/>
      </transition-group>
    </div>
    <img class="background" ref="background" :src="userShareImageLocal">
  </div>
</template>

<script>
import BaseLockup from '@/components/BaseLockup/BaseLockup'
import BaseText4 from '@/components/BaseText4/BaseText4'
import BaseText12 from '@/components/BaseText12/BaseText12'
import BaseText13 from '@/components/BaseText13/BaseText13'
import BaseTextAnimation1 from '@/components/BaseTextAnimation1/BaseTextAnimation1'
import BaseButtonBuy from '@/components/BaseButtonBuy/BaseButtonBuy'
import ShareModal from './partials/ShareModal/ShareModal'
import { opponentIds } from '@/data/opponents'
import { mapState, mapGetters } from 'vuex'
import { TimelineMax } from 'gsap'
export default {
  name: 'share',
  components: {
    BaseLockup,
    BaseText4,
    BaseText12,
    BaseText13,
    BaseTextAnimation1,
    BaseButtonBuy,
    ShareModal
  },
  mounted () {
    this.tl = this.createTl()
  },
  data () {
    return {
      shareModalState: false
    }
  },
  computed: {
    currentOpponentIndex () {
      return opponentIds.indexOf(this.selectedOpponentId)
    },
    isLastOpponent () {
      return this.currentOpponentIndex === opponentIds.length - 1
    },
    nextOpponentIndex () {
      let nextOpponentIndex = 0
      if (this.userWonGame) nextOpponentIndex = this.currentOpponentIndex + 1
      else nextOpponentIndex = this.currentOpponentIndex
      return nextOpponentIndex
    },
    ...mapState('gameplay', [
      'userShareImageLocal',
      'selectedOpponentId'
    ]),
    ...mapGetters('gameplay', [
      'userWonGame'
    ])
  },
  methods: {
    createTl () {
      const tl = new TimelineMax({ paused: true })
      tl.add([
        this.$refs['action-copy'].tl.play(),
        this.$refs['share-copy'].tl.play()
      ], 0, 'start', 0.2)
      return tl
    },
    animateIn () {
      this.tl.play()
    }
  }
}
</script>

<style lang="scss" scoped>
.share {
  width: 100%;
  height: 100%;
}
.content {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}
.section-main {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.share-modal {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 1;
}
.lockup {
  width: 8.5rem !important;
  margin: 0 auto;
  z-index: 1;
}
.action-container {
  display: flex;
  align-items: flex-end;
  margin-bottom: 2rem;
  .action-copy {
    width: 12.8rem;
    display: block;
    margin-bottom: -1.3rem;
    transform: skewX(-10deg);
  }
  .action-subcopy {
    font-size: 0.8rem;
    margin: 0 0 -0.25rem 0;
  }
}
.share-copy {
  margin-bottom: 0.25rem;
  transform: skewX(-10deg);
}
.share-subcopy {
  font-size: 0.8rem;
}
.image-container {
  display: flex;
  align-items: center;
}
.image {
  width: 50%;
  max-width: 20rem;
  margin-right: 2rem;
}
.share-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  cursor: pointer;
}
.buy-button {
  width: 16rem;
  z-index: 1;
}
.background {
  position: absolute;
  top: 50%;
  left: 50%;
  min-height: 220%;
  min-width: 100%;
  transform: translate(-50%, -50%);
  filter: brightness(0.3);
}
.base-text-4 {
  margin: 0;
}
</style>
